
export class SocialMediaShareService {
    getLineShareUrl(shareUrl: string, message?: string): string {
        const encodedMessage = message ? encodeURIComponent(message + "\n\n") : "";
        const encodedUrl = encodeURIComponent(shareUrl);

        return `https://line.me/R/msg/text/?${encodedMessage}${encodedUrl}`;
    }

    getFacebookShareUrl(shareUrl: string, message?: string): string {
        const encodedUrl = encodeURIComponent(shareUrl);
        return `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
    }
}
